<template>
    <b-row no-gutters
        id="download">
        <b-col cols="1"></b-col>
        <b-col cols="5"
            class="leftColumn">
            <h1 class="textTitle whiteBarbos leftTextAlign">
                ENCOMENDE CONNOSCO
            </h1>
            <h3 class="textSubTitle whiteBarbos leftTextAlign">
                Disponibilizamos soluções tecnológicas para o apoiar no seu negócio
            </h3>
            <p class="text whiteBarbos leftTextAlign">
                Temos à sua disposição métodos inovadores de realizar as suas encomendas através de plataforma web ou aplicações móveis. Aceda ao nosso catálogo de produtos, realize e visualize o estado das encomendas num clique.
            </p>
            <p class="text whiteBarbos leftTextAlign">
                Faça o <a href="/register">registo</a> da sua empresa na plataforma web e comece já a encomendar os nossos produtos.
            </p>
            <div class="leftTextAlign btnStoreContainer">
                <a href="https://play.google.com/store/apps/details?id=com.positiveblue.barbosapeixe"
                    target="_blank">
                    <b-img :src="require('../../assets/img/btn_google_play.png')"></b-img>
                </a>
                <a href="https://apps.apple.com/pt/app/barbosa-peixe/id1483943271"
                    target="_blank">
                    <b-img :src="require('../../assets/img/btn_app_store.png')"></b-img>
                </a>
            </div>
        </b-col>
        <b-col cols="5">
            <b-img :src="require('../../assets/img/mockup_aplicacao.png')"></b-img>
        </b-col>
        <b-col cols="1"></b-col>
    </b-row>
</template>

<script>
export default {
    name: 'Appdownload',
    props: {}
}
</script>
